import { Component, OnInit } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { CaseService } from '../services/case.service';
import { MenuController } from '@ionic/angular';
import { AuthService } from '../services/auth.service';
import { Subscription, interval } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-master',
  templateUrl: './master.page.html',
  styleUrls: ['./master.page.scss'],
})
export class MasterPage implements OnInit {
  private timerSubscription: Subscription;
  title = 'Lateral Debtor Portal';
  logo_url = '';

  constructor(
    private alertCtrl: AlertController,
    private caseService: CaseService,
    private menuController: MenuController,
    private authService: AuthService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    let settings = JSON.parse(localStorage.getItem('portal_settings'));
    if (settings?.portal_details?.title) {
      this.title = settings.portal_details.title;
    }
    if (settings?.theme_settings) {
      this.applyTheme(settings.theme_settings);
    }
  }

  openMenu() {
    this.menuController.enable(true, 'menu');
    this.menuController.open('menu');
  }

  async confirmLogout() {
    const alert = await this.alertCtrl.create({
      header: this.translate.instant('CONFIRM_LOGOUT.HEADER'),
      message: this.translate.instant('CONFIRM_LOGOUT.MESSAGE'),
      buttons: [
        {
          text: this.translate.instant('CONFIRM_LOGOUT.CANCEL'),
          role: 'cancel',
          handler: () => {},
        },
        {
          text: this.translate.instant('CONFIRM_LOGOUT.LOGOUT'),
          handler: () => {
            localStorage.removeItem('remote_token');
            let from_viewmycase = parseInt(
              localStorage.getItem('from_viewmycase')
            );
            if (from_viewmycase) {
              window.location.href = '/viewmycase';
            } else {
              window.location.href = '/login?dynamic=1';
            }
          },
        },
      ],
    });
    await alert.present();
  }
  ionViewWillEnter() {
    this.authService.saveDebtorDetails(localStorage.getItem('debtor_id'), true);
    this.timerSubscription = interval(1800000).subscribe(() => {
      this.authService.saveDebtorDetails(
        localStorage.getItem('debtor_id'),
        true
      );
    });
  }
  ionViewWillLeave() {
    this.timerSubscription.unsubscribe();
  }

  applyTheme(themeSettings: any) {
    const root = document.documentElement;

    // Iterate through the theme settings and set CSS variables
    for (const panelKey in themeSettings) {
      if (themeSettings.hasOwnProperty(panelKey)) {
        const colors = themeSettings[panelKey];
        for (const colorKey in colors) {
          if (colors.hasOwnProperty(colorKey)) {
            const isDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
            const target = isDark ? document.body : document.documentElement;
            target.style.setProperty(`--${colorKey.replace(/_/g, '-')}`, colors[colorKey]);
          }
        }
      }
    }
  }
}
